import { useSelector } from "react-redux";

import ArtExcJudge from "./ArtExcJudge";
import PreviousParticipant from "./PreviousParticipant";
import CurrentParticipant from "./CurrentParticipant";
import { Card } from "../../../components/Parts";
import styled from "styled-components";

const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  > div {
    margin: 0;
  }

  #prev-participant {
    width: 400px;
    padding-top: 60px;
    padding-bottom: 60px;
  }

  .e-tabs-grid-btn {
    flex: 0 0 12.5%;
  }
`;

const StyledCard = styled(Card)`
  max-width: 100%;
`;

const JudgeView = () => {
  const hasCurrentCompetitor = useSelector(
    (rootState) => !!rootState.competitors.find((c) => c.completed === false)
  );

  const userPositionType = useSelector(
    (rootState) => rootState.user.positionType
  );

  if (userPositionType !== "D") {
    return (
      <>
        <PreviousParticipant />
        {hasCurrentCompetitor && (
          <Card>
            <CurrentParticipant />
            <ArtExcJudge />
          </Card>
        )}
      </>
    );
  }

  return (
    <Wrap>
      <PreviousParticipant />
      {hasCurrentCompetitor && (
        <StyledCard>
          <CurrentParticipant />
          <ArtExcJudge />
        </StyledCard>
      )}
    </Wrap>
  );
};

export default JudgeView;
